import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { memo } from "react";
import { ButtonBase } from "./ButtonBase";
import { SlotsProvider } from "../providers/SlotsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx, slugify } from "../system";
import { Typography } from "./Typography";
export const tabClasses = {
    root: "MinervaTab-root",
    default: "MinervaTab-default",
    filled: "MinervaTab-filled",
    outline: "MinervaTab-outline",
    tonal: "MinervaTab-tonal",
    selected: "MinervaTab-selected",
    disabled: "MinervaTab-disabled",
};
export const tabSlots = {
    label: Typography,
};
export const Tab = memo((props) => {
    const { value, onClick, startNode, endNode, slots, slotProps, className, disabled, sx, children, ...rest } = useDefaultProps({ component: "Tab", props });
    return (_jsx(SlotsProvider, { baseSlots: tabSlots, slots: slots, children: ({ label: Label }) => (_jsxs(ButtonBase, { disabled: disabled, className: clsx([
                tabClasses.root,
                tabClasses.default,
                tabClasses.filled,
                tabClasses.outline,
                tabClasses.tonal,
                `${tabClasses.selected}-${typeof value === "string" ? slugify(value) : value}`,
                disabled && tabClasses.disabled,
                className,
            ]), sx: mergeSx({
                gap: 2,
                display: "flex",
                alignItems: "center",
                backgroundColor: "transparent",
            }, sx), onClick: () => onClick?.(value), ...rest, children: [startNode, typeof children === "string" ? (_jsx(Label, { variant: "body2", fontWeight: "semibold", ...slotProps?.label, children: children }, "tab-label")) : (children), endNode] })) }));
});
//# sourceMappingURL=Tab.js.map